import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CustomerModel }  from '../../app-lite/customers/models/customer';
import { SessionService } from '../../app-lite/sessions/session.service';

@Component({
  template: require('./customer.actions.component.html')
})
export class CustomerActionsComponent {
  @Input() record: CustomerModel;

  @Output() onEditClick      : EventEmitter<CustomerModel> = new EventEmitter();
  @Output() onAddVehicleClick: EventEmitter<CustomerModel> = new EventEmitter();
  @Output() onBookingClick   : EventEmitter<CustomerModel> = new EventEmitter();
  @Output() onInvoiceClick   : EventEmitter<CustomerModel> = new EventEmitter();
  @Output() onSMSClick       : EventEmitter<CustomerModel> = new EventEmitter();
  @Output() onEmailClick     : EventEmitter<CustomerModel> = new EventEmitter();
  @Output() onActivateClick  : EventEmitter<CustomerModel> = new EventEmitter();

  session = this.sessionService.base();

  constructor (
    private sessionService: SessionService
  ) {}
}